import {Box, Button, Grid, Paper, Typography, styled} from '@mui/material'
import theme from '../../themes'

export const DivContainer = styled('div')(({theme}) => ({
  backgroundColor: theme.palette.common.white
}))

export const LogoContainer = styled('div')(() => ({
  padding: '3%'
}))

export const BoxContainer = styled('div')(() => ({
  display: 'flex',
  alignContent: 'center',
  justifyContent: 'center'
}))

export const StyledBox = styled(Box)(() => ({
  display: 'flex',
  alignContent: 'center',
  justifyContent: 'center',
  flexWrap: 'wrap',
  '@media (min-width:1024px)': {
    minWidth: '500px'
  },
  '@media (min-width:320px) and (max-width: 1024px)': {
    minWidth: '-webkit-fill-available'
  }
}))

export const StyledPaper = styled(Paper)(() => ({
  width: '100%',
  padding: '5%'
}))

export const StyledTypography = styled(Typography)(() => ({
  display: 'flex',
  alignContent: 'center',
  justifyContent: 'center',
  fontSize: theme.typography.heading.fontSize.m,
  paddingBottom: '10px'
}))

export const ButtonContainer = styled('div')(() => ({
  display: 'flex',
  alignContent: 'center',
  justifyContent: 'center',
  paddingTop: '10px'
}))

export const StyledButton = styled(Button)(() => ({
  color: theme.palette.common.white,
  backgroundColor: theme.palette.common.successGreen,
  border: `1px solid ${theme.palette.common.lightGrey}`,
  textTransform: 'none',
  width: '100%',
  ':hover': {
    backgroundColor: theme.palette.common.successGreen
  },
  fontSize: theme.typography.heading.fontSize.s
}))

export const StyledImageDiv = styled('div')(() => ({
  display: 'flex',
  alignContent: 'bottom',
  justifyContent: 'right',
  position: 'absolute',
  right: '10px',
  top: '10px'
}))

export const StyledFooterDiv = styled('div')(() => ({
  height: '65px',
  bottom: '0px',
  position: 'absolute',
  width: '99%',
  textAlign: 'center',
  display: 'flex'
}))

export const StyledCookieButton = styled(Button)(() => ({
  color: theme.palette.common.black,
  textTransform: 'none',
  fontSize: theme.typography.heading.fontSize.s
}))

export const StyledImage = styled('img')(() => ({
  width: '75%',
  margin: 'auto',
  display: 'block'
}))

export const StyledImageGridDiv = styled(Grid)(() => ({
  margin: 'auto',
  alignSelf: 'center'
}))

export const StyledGrid = styled(Grid)(() => ({
  alignSelf: 'center',
  paddingBottom: '7%',
  '&.MuiGrid-item': {paddingLeft: '10%'}
}))
